import(/* webpackMode: "eager" */ "/var/www/farmtradedirect/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Plus_Jakarta_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"],\"variable\":\"--font-plus-jakarta-sans\",\"display\":\"swap\"}],\"variableName\":\"plusJakartaSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/var/www/farmtradedirect/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/var/www/farmtradedirect/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/farmtradedirect/src/styles/tailwind.css");
